<template>
<el-dialog :title="!dataForm.userId ? '新增' : '修改'" :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
        <el-form-item label="真实姓名" prop="realName">
            <el-input v-model="dataForm.realName" placeholder="真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="账户名" prop="username">
            <el-input v-model="dataForm.username" placeholder="账户名"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIdList">
            <el-dict-select v-model="dataForm.roleIdList" multiple type="roleList" :params="rolelistParams" :props="{ value: 'roleId', label: 'roleName' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="教务" prop="eduManager">
            <el-switch v-model="dataForm.eduManager" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
            <el-dict-select v-model="dataForm.gender" placeholder="性别" type="listByType" :params="genderParams" :props="dictProps"></el-dict-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
            <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="weChat">
            <el-input v-model="dataForm.weChat" placeholder="微信"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
            <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <span style="margin-right: 300px; font-size: xx-small" v-if="!dataForm.userId"><span style="color: red">注意事项</span>: 新增用户默认密码 456123，为了防止盗号，请尽快修改！</span>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()" :loading="loading">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            dataForm: {
                username: undefined,
                realName: undefined,
                eduManager: false,
                gender: undefined,
                email: undefined,
                mobile: undefined,
                weChat: undefined,
                userStage: undefined,
                roleIdList: []
            },
            dataRule: {
                username: [{
                    required: true,
                    message: '请输入账户名',
                    trigger: 'blur'
                }],
                mobile: [{
                    required: true,
                    message: "请输入手机号",
                    trigger: "blur"
                }, ],
                roleIdList: [{
                    required: true,
                    message: "请选择角色",
                    trigger: "blur"
                }, ],
            }
        }
    },
    methods: {
        init(userId) {
            this.dataForm.userId = userId
            this.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm.userId) {
                    this.$http({
                        url: this.$http.adornUrl(`sys/user/info/${this.dataForm.userId}`),
                        method: 'get'
                    }).then(({
                        data
                    }) => {
                        console.log(data.user)
                        if (data && data.code === 0) {
                            this.dataForm.username = data.user.username
                            this.dataForm.realName = data.user.realName
                            this.dataForm.eduManager = data.user.eduManager
                            this.dataForm.gender = data.user.gender
                            this.dataForm.userStage = data.user.userStage
                            this.dataForm.email = data.user.email
                            this.dataForm.mobile = data.user.mobile
                            this.dataForm.weChat = data.user.weChat
                            this.$nextTick(() => {
                                this.dataForm.roleIdList = data.user.roleIdList
                            })
                        }
                    })
                }
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$http({
                        url: this.$http.adornUrl(`/sys/user/${!this.dataForm.userId ? 'save' : 'update/' + this.dataForm.userId}`),
                        method: `${this.dataForm.userId ? 'put' : 'post'}`,
                        data: this.$http.adornData({
                            ...this.dataForm,
                            userType: 'TEACHER'
                        })
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.$message({
                                message: this.dataForm.userId ? '更新成功' : '新建成功',
                                type: 'success'
                            })
                            this.visible = false
                            this.$emit('refreshDataList')
                        } else {
                            this.$message.error(data.msg)
                        }
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        }
    },
    computed: {
        dictProps() {
            return {
                value: 'code',
                label: 'value'
            }
        },
        genderParams() {
            return {
                type: 'Gender'
            }
        },
        groupStageParams() {
            return {
                type: 'StudentStage'
            }
        },
        rolelistParams() {
            return {
                orgId: this.dataForm.orgId,
                name: '教师'
            }
        }
    }
}
</script>
